// Import Components
import Header from './components/Header';
import Projects from './components/Projects';
import Social from './components/Social';
import Footer from './components/Footer';
import Banner from './components/Banner';

function App() {
	return (
		<div className = "background">
			<div className = "App">
				<Banner />
				<Header />
				<Projects />
				<Social />
				<Footer />
			</div>
		</div>

		
	);
}

export default App;
